const keys = (o) => Object.keys(o);
var keys_default = keys;
export {
  keys_default as default
};
//# sourceMappingURL=keys.js.map